module.exports = __webpack_public_path__ + "static/media/ic-3.50eb8274.svg";